
import type { FixSession, TranslationFix, Language } from './types';

export class TranslationSessionManager {
  private sessionStorage = typeof window !== 'undefined' ? window.sessionStorage : null;

  public storeSession(session: FixSession): void {
    if (this.sessionStorage) {
      this.sessionStorage.setItem(
        'translation-fixes', 
        JSON.stringify(Array.from(session.appliedFixes.entries()))
      );
    }
  }

  public loadStoredFixes(): Map<string, string> {
    const fixes = new Map<string, string>();
    
    if (this.sessionStorage) {
      const stored = this.sessionStorage.getItem('translation-fixes');
      if (stored) {
        try {
          const storedFixes = JSON.parse(stored);
          return new Map(storedFixes);
        } catch (error) {
          console.warn('Could not parse stored translation fixes:', error);
        }
      }
    }
    
    return fixes;
  }

  public clearStoredFixes(): void {
    if (this.sessionStorage) {
      this.sessionStorage.removeItem('translation-fixes');
    }
  }

  public applyFixToSession(session: FixSession, keyPath: string, language: Language, value: string): void {
    const fixKey = `${language}.${keyPath}`;
    session.appliedFixes.set(fixKey, value);
    this.storeSession(session);
  }

  public getSessionFix(session: FixSession | null, language: Language, keyPath: string): string | null {
    const fixKey = `${language}.${keyPath}`;
    
    // First check current session
    if (session?.appliedFixes.has(fixKey)) {
      return session.appliedFixes.get(fixKey) || null;
    }

    // Then check session storage
    const storedFixes = this.loadStoredFixes();
    return storedFixes.get(fixKey) || null;
  }
}
